import request from '@/utils/request'
export function orderEtc(query) {
    return request({
        url: '/ntocc-tms-api/orderDetail/orderEtc',
        method: 'get',
        params: query
    })
}

export function orderEtcHistory(query) {
    return request({
        url: '/ntocc-tms-api/orderDetail/orderEtcHistory',
        method: 'get',
        params: query
    })
}

export function selectEtcOrderReport(query) {
    return request({
        url: '/ntocc-tms-api/etc/selectEtcOrderReport',
        method: 'post',
        params: query
    })
}

export function orderDetailEtcStart(query) {
    return request({
        url: `/ntocc-tms-api/etc/orderDetailEtcStart`,
        method: 'post',
        params: query
    })
}
export function orderDetailEtcInvoice(query) {
    return request({
        url: `/ntocc-tms-api/etc/orderDetailEtcInvoice`,
        method: 'post',
        params: query
    })
}
// 分单详情
export function selectAllSplitOrder(query) {
    return request({
        url: `ntocc-tms-api/etc/selectAllSplitOrder`,
        method: 'post',
        params: query
    })
}
// 开票分单
export function selectOrderSplitList(query) {
    return request({
        url: 'ntocc-tms-api/etc/selectOrderSplitList',
        method: 'post',
        params: query
    })
}
export function historySplitOrderEtcReport(query) {
    return request({
        url: 'ntocc-tms-api/etc/historySplitOrderEtcReport',
        method: 'get',
        params: query
    })
}
export function splitOrderEtcReport(query) {
    return request({
        url: 'ntocc-tms-api/etc/splitOrderEtcReport',
        method: 'post',
        params: query
    })
}
export function splitOrderFindInvoice(query) {
    return request({
        url: 'ntocc-tms-api/etc/splitOrderFindInvoice',
        method: 'get',
        params: query
    })
}
export function getOrderDetailInvoiceBatch(query) {
    return request({
        url: 'ntocc-tms-api/etc/getOrderDetailInvoiceBatch',
        method: 'get',
        params: query
    })
}
